const getters = {
  getInsightPackages: (state) => state.packages,
  getInsights: (state) => state.insights.insights,
  getPackageInsights: (state) => state.packageInsights,
  getInsightsPackageFilter: (state) => state.insights.packages,
  getIgnoredLastInsight: (state) => state.ignoredLastInsight,
  getExploreInsightsFilter: (state) => state.exploreInsightsFilter,
  getRunningPackagesData: (state) => state.runningPackagesData,
  getRunnedPackages: (state) => state.runnedPackages,
  getPackageRunningStatus: (state) => state.isRunPackage,
  getSearchedInsightsResults: (state) => state.searchedInsightsResults,
  getInsightSearchText: (state) => state.insightSearchText,
  getWeeklyInsightChanges: (state) => state.weeklyInsightChanges,
  getSortedInsights: (state) => state.sortedInsights
};
export default getters;



// WEBPACK FOOTER //
// ./src/store/modules/insights/getters.js